var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBluePin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.038,
    height: 22.038,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 21361"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#185edf",
    "data-name": "Group 21360"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.98 4.09 4.088 6.98l3.615 3.615a5.054 5.054 0 0 1 1.446 2.892l4.338-4.338a5.1 5.1 0 0 1-2.891-1.446Z",
    "data-name": "Path 14076"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.556 6.483a2.746 2.746 0 0 1-3.889 0L8.426 3.24l.648-.648a.917.917 0 0 0-1.296-1.296L1.296 7.779a.917.917 0 1 0 1.296 1.296l.649-.648 3.241 3.241a2.746 2.746 0 0 1 0 3.889l1.296 1.296 3.87-3.87 4.537 4.538h1.297v-1.296l-4.538-4.538 3.91-3.909-1.297-1.296Zm-6.482 6.482a4.531 4.531 0 0 0-1.296-2.593L4.537 7.13 7.13 4.537 10.37 7.78a4.57 4.57 0 0 0 2.593 1.296Z",
    "data-name": "Path 14077"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluePin);
export default __webpack_public_path__ + "static/media/Blue_Pin.612b864270623dddb3bff25590e4c5f6.svg";
export { ForwardRef as ReactComponent };